// Navbar.js
import React from "react";
import { Link } from "react-router-dom";

// mobile view home menu

const HomeNavbar = () => {
  //nav items for every page
  const homeItems = {
    "/": ["WORK", "ABOUT", "CONTACT"],
  };

  return (
    <nav className="flex flex-col mb-8">
      {homeItems["/"].map((item, index) => (
        <Link
          key={index}
          to={`/${item.toLowerCase()}`}
          className="py-2 font-bold text-6xl text-midBrown active:text-pink"
        >
          {item}
        </Link>
      ))}
    </nav>
  );
};

export default HomeNavbar;
